/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MasterScheduleReferenceDataResponse } from '../../models/master-schedule-reference-data-response';

export interface GetMasterScheduleReferenceData$Params {
}

export function getMasterScheduleReferenceData(http: HttpClient, rootUrl: string, params?: GetMasterScheduleReferenceData$Params, context?: HttpContext): Observable<StrictHttpResponse<MasterScheduleReferenceDataResponse>> {
  const rb = new RequestBuilder(rootUrl, getMasterScheduleReferenceData.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MasterScheduleReferenceDataResponse>;
    })
  );
}

getMasterScheduleReferenceData.PATH = '/api/scheduler/master-schedule/reference-data';
